import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function DraftsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"drafts"}/>
}
